module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-stats"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": _vm.backgroundColor
    }
  }, [(!!_vm.icon) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), (!!_vm.faIcon) ? _c('i', {
    class: _vm.faIcon
  }) : _vm._e()]), _c('div', {
    staticClass: "card-content"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h3', {
    staticClass: "title"
  }, [_vm._t("content")], 2)]), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "stats"
  }, [_vm._t("footer")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d9958c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdStatsWidget/index.vue
// module id = 4Z3U
// module chunks = 13 14